import {Component} from "@angular/core";

@Component({
  selector: 'fabric8-spaces-list-toolbar',
  templateUrl: './list-toolbar.space.component.html',
  styleUrls: ['./list-toolbar.space.component.scss'],
})
export class SpacesListToolbarComponent {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
